import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_NEW_CLIENTS_WITHOUT_ORDERS} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NewClientsWithoutOrdersContent} from './NewClientsWithoutOrdersContent';
import reportPayload from './reportPayload';

export const NewClientsWithoutOrdersReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'New Clients Without Orders')}
      description={tt(
        'description',
        "They've signed up but haven't ordered their food yet. Remind them!",
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NewClientsWithoutOrdersContent}
    />
  );
};

export default withHOC(
  withTranslation('report.newClientsWithoutOrders'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_NEW_CLIENTS_WITHOUT_ORDERS,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(NewClientsWithoutOrdersReport);
